import { useState, useRef, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Presenter from './Presenter';
import { IContainerProps } from './types';
import { useClickOutside } from '../../hooks/useClickOutside';
import selectors from '../../state/selectors';
import actions from '../../state/actions';
import { IAppState } from '../../state/types';

const NavbarContainer = (props: IContainerProps) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
    const mobileMenuRef = useRef<HTMLDivElement>(null);
    const profileDropdownRef = useRef<HTMLDivElement>(null);
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const authUser = useSelector((state: IAppState) => selectors.auth.getAuthUser(state));

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    const toggleProfileDropdown = () => {
        setProfileDropdownOpen(!profileDropdownOpen);
    };

    const closeProfileDropdown = () => {
        setProfileDropdownOpen(false);
    };

    const handleLogout = () => {
        if (authUser) {
            dispatch(actions.auth.logoutRequest(authUser));
        }
        history.push('/');
    };

    // Close menus when clicking outside
    useClickOutside(mobileMenuRef, closeMobileMenu);
    useClickOutside(profileDropdownRef, closeProfileDropdown);

    // Close menus when route changes
    useEffect(() => {
        closeMobileMenu();
        closeProfileDropdown();
    }, [location.pathname]);

    // Close menus on Escape key
    useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                if (mobileMenuOpen) closeMobileMenu();
                if (profileDropdownOpen) closeProfileDropdown();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [mobileMenuOpen, profileDropdownOpen]);

    return (
        <Presenter
            {...props}
            mobileMenuOpen={mobileMenuOpen}
            toggleMobileMenu={toggleMobileMenu}
            mobileMenuRef={mobileMenuRef}
            profileDropdownOpen={profileDropdownOpen}
            toggleProfileDropdown={toggleProfileDropdown}
            closeProfileDropdown={closeProfileDropdown}
            profileDropdownRef={profileDropdownRef}
            authUser={authUser}
            onLogout={handleLogout}
        />
    );
};

export default NavbarContainer;
